import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faBullseyeArrow } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { StartNewCallAction } from 'src/app/store/samwin/client-phone/client-phone.actions';
import { DialTarget, NextDialTargetState } from 'src/app/store/samwin/next-dial-target/next-dial-target.state';

@Component({
   selector: 'samweb-next-dial-target',
   templateUrl: './next-dial-target.component.html',
   styleUrls: ['./next-dial-target.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NextDialTargetComponent implements OnInit, AfterViewInit {
   constructor(private store: Store) {}

   public phoneAnswerIcon: IconDefinition = WellKnownIconsEnum.CALLING_ANSWER.icon;
   public dialArrowIcon: IconDefinition = WellKnownIconsEnum.CALLING_DIAL_ARROW.icon;
   public bullsEyeIcon: IconDefinition = faBullseyeArrow;

   public nextDialTarget$: Observable<DialTarget>;

   ngOnInit() {
      this.nextDialTarget$ = this.store.select(NextDialTargetState.nextDialTarget).pipe(debounceTime(300));
   }

   ngAfterViewInit(): void {}

   callTarget() {
      this.store.dispatch(new StartNewCallAction(this.store.selectSnapshot(NextDialTargetState.nextDialTargetNumber)));
   }
}
